import React from 'react';
import styled from '@emotion/styled';

type Props = {
  htmlFor: string; // this must match the id of the associated input/field
  children: string | JSX.Element;
  className?: string;
};

const Label = styled.label`
  margin: 0;
  font-weight: normal;
`;

export function FieldLabel({ htmlFor, className, children }: Props) {
  return (
    <Label htmlFor={htmlFor} className={className}>
      {children}
    </Label>
  );
}
